import { Alert, Result, Space } from "antd";
import { BULK_ACTION_MAX_RECORDS } from "common/constants";
import { camelToWords, snakeToCamelCase } from "common/utils";
import styled from "styled-components";

const StyledCard = styled.div`
  margin-bottom: 32px;
  padding-top: 8px;
`;

const StyledAlertList = styled(Space)`
  width: 100%;
`;

export default function FinishStep({ previewData, isOverThresholdWithNonExempt = false }) {
  if (isOverThresholdWithNonExempt) {
    return (
      <StyledCard>
        <Result
          status="warning"
          title="This bulk action affects too many records"
          subTitle={
            <span>
              This action targets more than{" "}
              <strong>{BULK_ACTION_MAX_RECORDS.toLocaleString()}</strong> records. The selected
              operations cannot run on this many records. Please refine your filters or choose a
              Skip Trace operation, which is exempt from this limit.
            </span>
          }
        />
      </StyledCard>
    );
  }

  return (
    <StyledCard>
      <StyledAlertList direction="vertical" size="middle">
        {previewData?.map((item) => (
          <Alert
            description={`Based on your ${camelToWords(
              snakeToCamelCase(item.bulkActionOperation),
            )} operation, ${item.totalAffectedRecords} records will be affected across ${
              item.totalAffectedDebtors === null
                ? item.totalAffectedAccounts
                : item.totalAffectedDebtors
            } ${item.totalAffectedDebtors == null ? "accounts" : "debtors"}`}
            type="info"
            showIcon
          />
        ))}
      </StyledAlertList>
      <Result
        status="warning"
        title="Almost Done!"
        subTitle={
          <span>
            Please click "Confirm" to execute this bulk action. NOTE:{" "}
            <strong>Bulk actions are irreversible</strong>, so please ensure you have configured
            your filters and actions correctly before confirming.
          </span>
        }
      />
    </StyledCard>
  );
}
